var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBioenergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 261,
    viewBox: "0 0 258 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -3,
    width: 184.555,
    height: 184.555,
    rx: 14,
    transform: "rotate(45 129 -3)",
    fill: "#008E81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -2.29289,
    width: 183.555,
    height: 183.555,
    rx: 13.5,
    transform: "rotate(45 129 -2.29289)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8698 83.6542C100.151 81.7305 105.211 88.0516 106.97 93.3107C108.04 96.5082 109.258 100.045 110.488 103.613C112.701 110.038 114.95 116.566 116.432 121.408C117.161 123.788 117.622 127.616 117.478 131.788C117.331 136.028 116.545 141.079 114.434 145.785C112.29 150.563 108.767 154.993 103.289 157.673C97.8632 160.327 90.9503 161.056 82.3272 159.349C73.7914 157.66 67.5343 154.62 63.138 150.553C58.6826 146.431 56.3892 141.482 55.4824 136.548C53.7316 127.02 57.1911 117.885 58.7765 114.434C59.6275 112.581 61.3062 110.022 63.3452 107.33C65.4478 104.553 68.1332 101.374 71.1755 98.2578C77.1143 92.1748 84.9837 85.7378 92.8698 83.6542ZM96.7476 93.4153C96.0665 92.8606 95.5022 92.7603 94.9342 92.9104C89.3389 94.3887 82.8473 99.3822 77.173 105.194C74.4088 108.026 71.9747 110.91 70.0981 113.388C68.1579 115.95 66.9979 117.836 66.6039 118.693C65.2722 121.592 62.8975 128.332 64.0638 134.679C64.6156 137.682 65.9685 140.671 68.8058 143.296C71.7023 145.975 76.3843 148.492 83.8926 149.978C91.3135 151.446 96.3268 150.636 99.701 148.985C103.023 147.359 105.174 144.718 106.57 141.606C107.998 138.423 108.617 134.767 108.733 131.429C108.851 128.025 108.432 125.407 108.13 124.419C106.693 119.725 104.559 113.534 102.393 107.248C101.147 103.632 99.8891 99.9831 98.7472 96.5696C98.2687 95.1393 97.5031 94.0306 96.7476 93.4153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.505 78.171C132.712 77.2955 134.124 76.8751 135.619 76.8751H167.707C169.34 76.8751 171.48 77.277 173.117 79.1375C174.717 80.9561 175 83.2298 175 84.8126V100.688C175 107.237 171.929 112.572 167.299 116.099C162.755 119.561 156.715 121.325 150.205 121.325C136.12 121.325 128.326 109.668 128.326 100.688V84.8131L132.702 84.8126C128.326 84.8126 128.326 84.8131 128.326 84.8131L128.326 84.8031L128.326 84.7933L128.327 84.7725L128.327 84.7267L128.33 84.6183C128.332 84.5389 128.336 84.4444 128.343 84.3369C128.357 84.1235 128.383 83.8496 128.431 83.5336C128.525 82.924 128.72 82.0385 129.153 81.0953C129.595 80.1334 130.326 79.0267 131.505 78.171ZM167.852 86.4056C167.83 86.4034 167.784 86.4001 167.707 86.4001H166.249V100.688C166.249 103.664 164.944 106.266 162.281 108.296C159.533 110.389 155.363 111.8 150.205 111.8C140.953 111.8 137.078 104.407 137.078 100.688V86.4001L135.623 86.4M167.866 86.4075L167.852 86.4056Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.345 61C141.762 61 143.721 63.1323 143.721 65.7625V79.2906C143.721 81.9209 141.762 84.0532 139.345 84.0532C136.929 84.0532 134.97 81.9209 134.97 79.2906V65.7625C134.97 63.1323 136.929 61 139.345 61Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.471 61C164.888 61 166.847 63.1323 166.847 65.7625V79.2906C166.847 81.9209 164.888 84.0532 162.471 84.0532C160.055 84.0532 158.096 81.9209 158.096 79.2906V65.7625C158.096 63.1323 160.055 61 162.471 61Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.282 118.253C155.282 115.623 153.323 113.491 150.906 113.491C148.49 113.491 146.53 115.623 146.53 118.253V145.477C146.53 163.701 132.957 178.475 116.213 178.475C99.4698 178.475 85.8964 163.701 85.8964 145.477L85.896 145.409C85.8101 138.873 87.0011 132.392 89.3901 126.394C90.3514 123.981 89.3333 121.176 87.1161 120.13C84.8989 119.084 82.3222 120.192 81.361 122.605C78.4829 129.83 77.046 137.638 77.1451 145.512C77.1622 168.981 94.6471 188 116.213 188C137.79 188 155.282 168.962 155.282 145.477V118.253Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_79",
    x: 0.298998,
    y: 2.799,
    width: 257.402,
    height: 257.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioenergy);
export default __webpack_public_path__ + "static/media/bioenergy.aff099448fb33583b1f24080fa4cf3a0.svg";
export { ForwardRef as ReactComponent };